// TODO cleanup / transfer to smaller files
import startCase from 'lodash.startcase';
import { actions as notifications } from '@saucelabs/sl-container-notifications';
import { constants as notificationConstants } from '@saucelabs/sl-module-notifications';
import {
  IconApiTestingOutline,
  IconDevicePhoneOutline,
  IconManualOutline,
  IconAutomatedOutline,
} from '@saucelabs/ds-icons';

import { definedPostalCodes } from './postalCodesRegex';
import {
  PLAN_INTERVAL,
  PRODUCT_LIVE,
  PRODUCT_RDC,
  PRODUCT_VDC,
  PRODUCT_AUTOMATED,
  PRODUCT_MOBILE_QUALITY,
  PRODUCT_API_TESTING,
} from './constants';

// Used across multiple containers
export const showSuccessMessage = (message, dispatch) => {
  const payload = {
    header: null,
    category: notificationConstants.CATEGORY_SUCCESS,
    persist: false,
    position: 'center',
    text: message,
    width: 'tiny',
  };

  dispatch(notifications.notify(payload));
};

export const formatPaymentFormValues = (values) => ({
  email: values.email,
  billing_info: {
    address1: values.address1,
    address2: values.address2,
    city: values.city,
    company: values.company,
    country: values.country,
    firstName: values.firstName,
    lastName: values.lastName,
    postalCode: values.postalCode,
    state: values.state,
    vatNumber: values.vatNumber || '', // Allow VAT ID removal for user
  },
});

export const getPostalCodeValidationRegexFor = (countryCode) => (
  definedPostalCodes
    .find((definedPostalCodesRegex) => definedPostalCodesRegex.countryCode === countryCode)
);

export const cardCodeToWording = (value) => {
  const code = value === 'master' ? 'master card' : value;
  return startCase(code);
};

/**
 * Sanitize input for alphanumeric and - _ + characters
 * @param {string} value
 * @return {string}
 */
export const sanitizeInputAlphanumeric = (value) => {
  if (!value) return value;
  // any digit, letter and - _ + characters
  return value.replace(/[^a-zA-Z0-9-_+]/g, '');
};

/**
 * Get product name from the plan code
 * @param {string} planCode
 * @returns {string}
 */
export const planToProduct = (planCode) => (
  planCode.replace('unified-', '').replace(/-(monthly|annual)$/, '')
);

/**
 * Map plan interval to name
 * FIXME: Probably redundant, can be replaced with Subscription.getInterval
 * @param {bool} isMonthly
 * @returns {string}
 */
export const getIntervalUnit = (isMonthly) => (
  isMonthly ? PLAN_INTERVAL.MONTH : PLAN_INTERVAL.YEAR
);

/**
 * Map product type to Icon
 * @param {string} productType
 * @returns {string}
 */
export const productTypeToIcon = (productType) => {
  switch (productType) {
    case (PRODUCT_LIVE): return IconManualOutline;
    case (PRODUCT_RDC):
    case (PRODUCT_VDC):
    case (PRODUCT_AUTOMATED): return IconAutomatedOutline;
    case (PRODUCT_MOBILE_QUALITY): return IconDevicePhoneOutline;
    case (PRODUCT_API_TESTING): return IconApiTestingOutline;
    default: return undefined;
  }
};
